import { ComponentProps, FC, ReactNode } from "react";
import { Link } from "react-router";
import { Text } from "@postenbring/hedwig-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleCheck } from "@fortawesome/pro-solid-svg-icons/faCircleCheck";
import { faLock } from "@fortawesome/pro-solid-svg-icons/faLock";
import { faBan } from "@fortawesome/pro-solid-svg-icons/faBan";
import Translated from "../infrastructure/translation/Translated";
import { TranslationKey } from "../infrastructure/translation/translator";
import { useClientPaths } from "../Client/useClientPaths";
import { useHomeStats } from "./homeRouteContext";
import styles from "./Home.module.css";

interface StatCardProps {
  icon: ComponentProps<typeof FontAwesomeIcon>["icon"];
  value: number;
  labelKey: TranslationKey;
  to: string;
  variant: "clients" | "certificates" | "revoked";
  children?: ReactNode;
}

const StatCard: FC<StatCardProps> = ({
  icon,
  value,
  labelKey,
  to,
  variant,
  children,
}) => (
  <Link to={to} className={`${styles.card} ${styles[variant]}`}>
    <span className={styles.cardIcon}>
      <FontAwesomeIcon icon={icon} />
    </span>
    <span className={styles.cardValue}>{value}</span>
    <span className={styles.cardLabel}>
      <Translated textKey={labelKey} />
    </span>
    {children}
  </Link>
);

export const HomePage: FC = () => {
  const stats = useHomeStats();
  const paths = useClientPaths();
  const certificatesPath = `${paths.organization}/certificates`;

  return (
    <section className={styles.section}>
      <div className={styles.intro}>
        <Text variant="h3" as="h2" size="min">
          <Translated textKey={"home.header"} />
        </Text>
      </div>

      <div className={styles.grid}>
        <StatCard
          icon={faCircleCheck}
          value={stats.clientCount}
          labelKey="home.active_clients"
          to={`${paths.organization}/clients`}
          variant="clients"
        />
        <StatCard
          icon={faLock}
          value={stats.certificateActive}
          labelKey="home.active_certificates"
          to={certificatesPath}
          variant="certificates"
        ></StatCard>
        <StatCard
          icon={faBan}
          value={stats.certificateRevoked}
          labelKey="home.revoked_certificates"
          to={certificatesPath}
          variant="revoked"
        />
      </div>
    </section>
  );
};
